export * from "./PTableExtend.type";
export * from "./PTableExtend.vue";
